// file name lolol
import { createSlice } from "@reduxjs/toolkit";

const toastSlice = createSlice({
  name: "toast",
  initialState: {
    show: false,
    message: "",
    severity: "info",
    vertical: "bottom",
    autoClose: null,
  },

  reducers: {
    showToast: (state, action) => {
      const incoming = (action.payload?.message ?? "").toString().trim();
      // Suppress empty toasts
      if (!incoming) {
        state.show = false;
        state.message = "";
        state.severity = "info";
        state.vertical = "bottom";
        state.autoClose = null;
        return;
      }

      state.message = incoming;
      state.severity = action.payload.severity || "info";
      state.vertical = action.payload.vertical || "bottom";
      state.autoClose = action.payload.autoClose ? 5000 : null;
      state.show = true;
    },

    hideToast: (state) => {
      state.show = false;
      state.autoClose = null;
      state.message = "";
      state.vertical = "bottom";
      state.autoClose = null;
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;

export const selectToast = (state) => state?.toast;

export default toastSlice.reducer;
